import getCurrentStepName from './getCurrentStepName';

export default getCurrentStepName;
